import {useState, useEffect} from 'react';
import {insertProduct, setInventory, updateInventoryAlert} from "../../api/Api";
import {Button, Checkbox, Collapse, Popover, Row, Col, Input, InputNumber, Select, Card, Divider} from "antd";
import {
    BulkSizeType,
    CategoryType,
    getOptions,
    ProductType,
    StrainType, UnitType
} from "../../api/Constants";
import {VendorSelectWidget} from "../widget/VendorSelectWidget";
import {getSubTypeOptions} from "../../util/inventoryUtils"
import {toUtcDateString} from "../../util/timeutils";
import {getAllProducts} from "../../api/Api";
import {SimpleProductTable} from "./SimpleProductTable";

const generateDateSku = (name, description) => {
    const result = `${toUtcDateString(new Date())}-${name}-${description}`;
    return result.replaceAll(" ", "-");
}

const generateBulkSku = (productSku, bulkSize) => {
    const result = `${productSku}-${toUtcDateString(new Date())}-${BulkSizeType.Label[bulkSize]}`
    return result.replaceAll(" ", "-");
}

export const NewProduct = ({category, refresh, onApiFail, onUpdate, props}) => {
    const [inventoryName, setInventoryName] = useState("");
    const [inventoryDescription, setInventoryDescription] = useState("");
    const [type, setType] = useState(undefined);
    const [subType, setSubType] = useState(undefined);
    const [inventoryQuantity, setInventoryQuantity] = useState(undefined);

    const [sku, setSku] = useState("");
    const [vendor, setVendor] = useState(undefined);
    const [strain, setStrain] = useState(StrainType.Indica);
    const [bulkSize, setBulkSize] = useState(BulkSizeType.Bigs);
    const [bulkCost, setBulkCost] = useState(0);

    const [cost, setCost] = useState(undefined);
    const [book, setBook] = useState(false);

    const [shipping, setShipping] = useState(undefined);
    const [tariff, setTariff] = useState(undefined);
    const [brand, setBrand] = useState("");
    const [alertQuantity, setAlertQuantity] = useState(undefined);

    const [submitDisabled, setSubmitDisabled] = useState(false);

    const [inventory, setInventoryList] = useState([]);

    useEffect(() => {
        console.log(`use effect`)
        getAllProducts().then((x) => {
            const tableData = x.map((val, index) => {
                return {...val, key: index}
            });
            console.log(tableData);
            setInventoryList(tableData);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail]);


    const onNameChange = (e) => {
        setInventoryName(e.target.value);
        if (category === CategoryType.Wholesale) {
            setSku(generateBulkSku(e.target.value, bulkSize));
        } else {
            setSku(generateDateSku(e.target.value, inventoryDescription));
        }
    }

    const onDescriptionChange = (e) => {
        setInventoryDescription(e.target.value);
        if (category !== CategoryType.Wholesale) {
            setSku(generateDateSku(inventoryName, e.target.value));
        }
    }

    const onQuantityChange = (val) => {
        // const val = parseInt(e.target.value, 10);
        if (isNaN(val)) {
            console.log(`quantity is not a value`);
        } else {
            setInventoryQuantity(val);
        }
    }

    const onTypeChange = (val) => {
        setType(val);
    }

    const onSubTypeChange = (val) => {
        setSubType(val);
    }

    const onSubmit = () => {
        console.log(`name ${inventoryName} description ${inventoryDescription} quantity ${inventoryQuantity}`)
        let theCost;
        let unit;
        if (category === CategoryType.Wholesale) {
            theCost = parseFloat((inventoryQuantity * bulkCost).toFixed(2));
            unit = UnitType.Gram;
        } else {
            theCost = cost;
            unit = UnitType.Each;
        }
        setInventory(inventoryName, inventoryDescription, inventoryQuantity, category, type, subType,
            {
                sku, vendorId: vendor && vendor.id, strain, cost: theCost, book, bulkSize,
                shipping: (shipping === undefined) || (shipping === null) ? 0 : shipping,
                tariff: (tariff === undefined) || (tariff === null) ? 0 : tariff,
                bulkCost, unit
        }).then(res => {
            if (category === CategoryType.Supplies) {
                updateInventoryAlert(res.id, alertQuantity, true).then(r => {
                    console.log(`updated supply alert`);
                }).catch(e => {
                    console.log(e);
                });
            }
            clearInputs();
            if (onUpdate) onUpdate();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onSubmitProduct = () => {
        insertProduct(inventoryName, inventoryDescription, category, type, subType,
            {
                sku, vendorId: vendor && vendor.id, strain, bulkSize
            }).then(res => {
            clearInputs();
            if (onUpdate) onUpdate();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onSkuChange = (e) => {
        setSku(e.target.value);
    }

    const onVendorIdChange = (val, option) => {
        console.log(val);
        setVendor(option.vendor)
    }

    const productTypeOptions = getOptions(ProductType) ();
    const strainOptions = getOptions(StrainType) ();
    const bulkSizeOptions = getOptions(BulkSizeType) ();
    const productSubtypeOptions = getSubTypeOptions(type);
    const subtypeDisabled = type === (undefined) || type === null;

    // const onUnitChange = (val) => {
    //     setUnit(val);
    // }

    const onCostChange = (val) => {
        setCost(val);
    }

    const onBulkCostChange = (val) => {
        setBulkCost(val);
    }


    const onStrainChange = (val) => {
        setStrain(val);
    }

    const onBookChange = (e) => {
        setBook(e.target.checked);
    }

    const onShippingChange = (val) => {
        setShipping(val);
    }

    const onTariffChange = (val) => {
        setTariff(val);
    }

    const onBrandChange = (e) => {
        setBrand(e.target.value);
    }

    const onBulkSizeChange = (val) => {
        setBulkSize(val);
        if (category === CategoryType.Wholesale) {
            setSku(generateBulkSku(inventoryName, val))
        }
    }

    const onAlertQuantityChange = (val) => {
        setAlertQuantity(val);
    }

    const clearInputs = () => {
        setInventoryName("");
        setInventoryDescription("");
        setInventoryQuantity(undefined);
        setType(undefined);
        setSubType(undefined);
        setShipping(undefined);
        setTariff(undefined);
        setBrand("");
        setBook(false);

        setCost(undefined);
        // setStrain(StrainType.Indica);
        setVendor(undefined);
        setSku("");
        setBulkCost(0);
        setAlertQuantity(undefined);
    }

    const onCollapseChange = (key) => {
        if ((Array.isArray(key) && (key[0]) !== undefined)) {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }
    }

    const typeIsUndefined = type === undefined || type === null;
    const subTypeIsUndefined = subType === undefined || subType === null;
    const productIsIncomplete = inventoryName === null || inventoryName === undefined
        || inventoryName.length === 0 || sku === null || sku === undefined || sku.length === 0
    || typeIsUndefined || subTypeIsUndefined;

    const submitButtonDisabled = submitDisabled || productIsIncomplete;

    let submitInventoryDisabled = productIsIncomplete || (inventoryQuantity === undefined) || (inventoryQuantity === null) ||
        (inventoryQuantity === 0);

    const popoverCollapseContent = "Additionally add Product to Inventory"

    let filteredInventory = [];
    let previewContent = <div/>;
    if (inventoryName.length > 2) {
        filteredInventory = inventory.filter(row => row.name.toLowerCase().includes(inventoryName.toLowerCase()));
        previewContent = <Card style={{textAlign: 'left'}} title={<b>Similar Products</b>}>
            <SimpleProductTable inventory={filteredInventory} />
        </Card>
    }

    let productUI, productInventoryUI;
    if (category === CategoryType.Wholesale) {
        productUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><Select options={strainOptions} placeholder={"strain"} onChange={onStrainChange}
                             value={strain}/></Col>
                <Col span={2}><Select style={{width:100}} options={bulkSizeOptions} value={bulkSize} onChange={onBulkSizeChange} popupMatchSelectWidth={false} /></Col>
            </Row>
        </div>
        productInventoryUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}>
                    <Popover content={"Sku"}>
                    <Input placeholder={"Sku"} onChange={onSkuChange} value={sku}/>
                    </Popover>
                </Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={9} placeholder={'cost'} addonBefore={"Cost/g $"} onChange={onBulkCostChange} value={bulkCost} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><Checkbox checked={book} onChange={onBookChange}>Book</Checkbox></Col>
            </Row>
        </div>
        submitInventoryDisabled = submitInventoryDisabled || (bulkCost === undefined) || (bulkCost === null);
    } else if (category === CategoryType.Packaged) {
        productUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><Select options={strainOptions} placeholder={"strain"} onChange={onStrainChange} value={strain} /></Col>
            </Row>
        </div>

        productInventoryUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><Input placeholder={"Sku"} onChange={onSkuChange} value={sku}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'cost'} addonBefore={"Cost $"} onChange={onCostChange} value={cost} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><Checkbox checked={book} onChange={onBookChange}>Book</Checkbox></Col>
            </Row>
        </div>

        submitInventoryDisabled = submitInventoryDisabled || (cost === undefined) || (cost === null);
    } else {
        productUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><Input placeholder={"Brand"} onChange={onBrandChange} value={brand} /></Col>
            </Row>
        </div>

        productInventoryUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><Input placeholder={"Sku"} onChange={onSkuChange} value={sku}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'price'} addonBefore={"Price $"} onChange={onCostChange} value={cost}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'shipping'} addonBefore={"Shipping Cost $"} onChange={onShippingChange} value={shipping} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'tariff'} addonBefore={"Tariff $"} onChange={onTariffChange} value={tariff} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={0} addonBefore={"Low Inventory Alert"} placeholder={'Alert'} onChange={onAlertQuantityChange} value={alertQuantity} /></Col>
            </Row>
        </div>

        submitInventoryDisabled = submitInventoryDisabled || (cost === undefined) || (cost === null) || (alertQuantity===null) || (alertQuantity === undefined);
    }


    return <div>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={12}>
                <Popover content={`Example: Bazinga, Runts Jealousy, Lemon Squeeze`}>
                <Input placeholder={"Name"} onChange={onNameChange} value={inventoryName} />
                </Popover>
            </Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={12}>
                <Popover content={`Examples: Indoor Flower, light dep, outdoor, Liters, Badder, shatter, crumble`}>
                <Input placeholder={"Description"} onChange={onDescriptionChange} value={inventoryDescription}/>
                </Popover>
            </Col>
        </Row>
        <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={3}>
                <Select options={productTypeOptions} placeholder={"type"} onChange={onTypeChange} value={type} popupMatchSelectWidth={false}/>
            </Col>
            <Col span={3}>
                <Select options={productSubtypeOptions} placeholder={"Subtype"} onChange={onSubTypeChange} value={subType} disabled={subtypeDisabled} popupMatchSelectWidth={false}/>
            </Col>
        </Row>
        <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={12}>
                <VendorSelectWidget onApiFail={onApiFail} onSelect={onVendorIdChange} />
            </Col>
        </Row>
        {productUI}
        <Row style={{paddingTop: '5px', paddingBottom: '5px'}}><Col span={12} style={{textAlign: 'left'}}><Collapse
            items={[{key: '1', label: <Popover content={popoverCollapseContent}>Add Inventory</Popover>,
                children: <div>
                    <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                        <Col span={12}><InputNumber min={0} placeholder={"Quantity"} onChange={onQuantityChange} value={inventoryQuantity}/></Col>
                    </Row>
                    {productInventoryUI}
                    <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                        <Col><Popover content={'Create Product and add it to Inventory'}>
                            <Button onClick={onSubmit} disabled={submitInventoryDisabled}>Create & Add to Inventory</Button>
                        </Popover></Col>
                    </Row>
                </div>
            }]}
            onChange={onCollapseChange}
        /></Col></Row>
        <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col><Popover content={'Create Product Listing,  do not modify Inventory'}>
                <Button disabled={submitButtonDisabled} onClick={onSubmitProduct}>Create Product</Button>
            </Popover></Col>
        </Row>
        <Divider />
        {previewContent}
    </div>
}